import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import './index.css';
import App from './App';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import PasswordReset from './pages/Auth/PasswordReset';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import CategorySets from './pages/Profiles/CategorySets';
import CategoryJobs from './pages/Jobs/CategoryJobs';
import Settings from './pages/Settings/Settings';
import Help from './pages/Settings/Help';
import PlanSelection from './pages/Payment/PlanSelection';
import UserSettings from './pages/Auth/UserSettings';
import RequirePlan from './routes/RequirePlan';
import SubmitJob from './pages/Jobs/SubmitJob';
import NewCategorization from './pages/Jobs/NewCategorization';
import ProfileDashboard from './pages/Profiles/ProfileDashboard';
import JobDashboard from './pages/Jobs/JobDashboard';
import reportWebVitals from './reportWebVitals';

function ProfileDashboardRoute() {
  const { id } = useParams();
  return <ProfileDashboard profileId={id as string} />;
}
function JobDashboardRoute() {
  const { id } = useParams();
  return <JobDashboard jobId={id as string} />;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/plans" element={<PlanSelection />} />

        <Route
          path="/app"
          element={
            <RequirePlan>
              <DashboardLayout />
            </RequirePlan>
          }
        >
          <Route index element={<Navigate to="/app/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="category-sets" element={<CategorySets />} />
          <Route path="category-jobs" element={<CategoryJobs />} />
          <Route path="new" element={<NewCategorization />} />
          <Route path="profile/:id" element={<ProfileDashboardRoute />} />
          <Route path="job/:id" element={<JobDashboardRoute />} />
          <Route path="settings" element={<Settings />} />
          <Route path="user-settings" element={<UserSettings />} />
          <Route path="help" element={<Help />} />
        </Route>

        <Route path="/submit-job" element={<SubmitJob />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
